import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
// core
import {
  Typography,
  Paper,
} from '@material-ui/core';

// components
import Snackbar from '../../../../components/Snackbar';
import Button from '../../../../components/Button';
import TasksTable from '../../TasksTable';
import useStyles from './styles';
import CreateTaskModal from '../../CreateTaskModal';
import FileUploadDialog from '../../FileUploadDialog';

const TaskList = () => {
  const [openFileDialog, setOpenFileDialog] = useState(false);
  const styles = useStyles();
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [severity, setSeverity] = useState('');
  const [message, setMessage] = useState('');
  const taskInfo = {
    project: '',
    title: '',
    type: '',
    requiredGeoreference: false,
    revisionPolicy: '',
    surveyTeleauditId: '',
    surveyTeleaudit: 0,
  };

  const tableHeaders = [
    {
      id: 'id',
      label: t('task.columnNames.id'),
    },
    {
      id: 'name',
      label: t('task.columnNames.title'),
    },
    {
      id: 'type',
      label: t('task.columnNames.type'),
    },
    {
      id: 'taskAssigned',
      label: t('task.columnNames.taskAssigned'),
    },
    {
      id: 'createdAt',
      label: t('task.columnNames.createdAt'),
    },
    {
      id: 'actions',
      label: t('task.columnNames.actions'),
    },
  ];
  return (
    <>
      <div className={styles.content}>
        <div className={styles.header}>
          <Typography variant='h4' className={styles.title}>{t('task.title')}</Typography>
          <Button
            id="upload-btn"
            variant="outlined"
            className={styles.createButton}
            text={t('task.configMail')}
            height="40px"
            width="220px"
            backgroundColor='theme-custom-successButtonBackground'
            color='theme-custom-solidButtonText'
            borderRadius='10px'
            onClick={() => setOpenFileDialog(true)}
          />
          <Button
            id="save-btn"
            variant="outlined"
            className={styles.createButton}
            text={t('task.createButton')}
            height="40px"
            width="220px"
            backgroundColor='theme-custom-solidButtonBackground'
            color='theme-custom-solidButtonText'
            borderRadius='10px'
            onClick={() => setOpen(true)}
          />
        </div>
        <Paper className={styles.taskTable}>
          <TasksTable
            setSeverity={setSeverity}
            setMessage={setMessage}
            tableHeaders={tableHeaders}
            setOpen={setOpen}
            allowCheckIn
            readOnly
          />
          {/* TODO: revisar el taskinfo */}
          <CreateTaskModal
            defaultOpen={open}
            setCurrentOpen={setOpen}
            taskInfo={taskInfo}
          />
          <FileUploadDialog
            open={openFileDialog}
            onClose={() => setOpenFileDialog(false)}
          />
          <Snackbar
            open={message !== ''}
            message={message}
            severity={severity}
            onClose={() => setMessage('')}
          />
        </Paper>
      </div>
    </ >
  );
};

export default TaskList;
